import { GTMMyAccountEvent, GTMAddSignInInfoEvent } from '../utils/gtm-utilities.es6';
import { capitalize } from '../utils/generic-utilities.es6';

const CHECKOUT_URL = '/checkout';
const SOCIAL_SIGN_IN_KEY = 'socialSignIn';

function GTMCheckoutEventsPusher(checkoutLoginType) {
    const checkoutOptions = {
        ecommerce: {
            checkout_option: {
                actionField: {
                    step: 2,
                    option: checkoutLoginType
                }
            }
        },
        checkout_login_type: checkoutLoginType
    };
    GTMAddSignInInfoEvent('checkout.checkoutOptions.signin', 'checkout', 'checkoutOptions', 'signin', checkoutOptions);
    localStorage.setItem('ga_checkoutLoginType', checkoutLoginType);
}

export const checkSocialUser = isUserLogged => {
    const searchParams = new URLSearchParams(window.location.search);
    const socialSignInValue = searchParams.get(SOCIAL_SIGN_IN_KEY);

    if (socialSignInValue) {
        const isCheckout = window.location.pathname.indexOf(CHECKOUT_URL) >= 0;
        GTMMyAccountEvent('myAccount.signIn', 'my account', isCheckout ? 'checkout sign in' : 'sign in', socialSignInValue);
        if (isCheckout) {
            const capitalizedValue = capitalize(socialSignInValue);
            if (isUserLogged === true) {
                GTMCheckoutEventsPusher(`${capitalizedValue} as Customer`);
            } else {
                GTMCheckoutEventsPusher(`${capitalizedValue} as Guest`);
            }
        }
    }
};
